import { useState } from 'react';
import { t } from '@exam-prep/i18n';
import { initialCalc, press } from './model/calculator';
import { ROWS } from './model/calculator-keys';

export function Calculator() {
  const [s, set] = useState(initialCalc);
  return (
    <div
      className="rounded-2xl border bg-card p-3 backdrop-blur-md"
      role="group"
      aria-label={t('miniapp.player.calculator')}
    >
      <div
        className="mb-3 rounded-xl border border-input bg-[var(--brand-surface-strong)] px-3 py-2.5 text-right font-mono text-2xl tabular-nums"
        aria-live="polite"
      >
        {s.memory !== 0 ? (
          <span className="float-left text-xs text-brand-amber-soft">M</span>
        ) : null}
        {s.display}
      </div>
      <div className="grid grid-cols-5 gap-1.5">
        {ROWS.flat().map(([k, label]) => (
          <button
            key={k}
            type="button"
            onClick={() => set((x) => press(x, k))}
            className={
              k === '='
                ? 'h-11 rounded-lg bg-[image:var(--brand-amber-gradient)] text-base font-bold text-[var(--brand-amber-ink)] active:brightness-95'
                : /^[0-9.]$/.test(k)
                  ? 'h-11 rounded-lg border bg-[var(--brand-surface-strong)] text-base font-semibold active:bg-accent'
                  : 'h-11 rounded-lg border bg-secondary text-sm text-muted-foreground active:bg-accent'
            }
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
